import { render, staticRenderFns } from "./DatosPersonalesFiguraAdicional.vue?vue&type=template&id=3c887b0b&lang=html&"
import script from "./DatosPersonalesFiguraAdicional.vue?vue&type=script&lang=js&"
export * from "./DatosPersonalesFiguraAdicional.vue?vue&type=script&lang=js&"
import style0 from "./DatosPersonalesFiguraAdicional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports